import { render, staticRenderFns } from "./ProjectFileCategoryList.vue?vue&type=template&id=06c42066&scoped=true&lang=pug&"
import script from "./ProjectFileCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProjectFileCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileCategoryList.vue?vue&type=style&index=0&id=06c42066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c42066",
  null
  
)

export default component.exports